/*
 * @Description: 人员盈利信息修改记录
 * @Author: 杨志航
 * @Date: 2026-08-11 16:34:55
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Descriptions,
  Table,
} from 'antd'

const ChangeLog = (props) => {
  const { editData } = props
  const [logList, setLogList] = useState([])

  useEffect(() => {
    api.getProfitReportChangeLog({
      reportId: editData.id
    }).then(data => {
      setLogList(data)
    })
  }, [])

  const logCol = [{ 
    title: '人员成本', 
    dataIndex: 'personalCost',
    align: 'center',
    render: text => text || '-'
  }, { 
    title: '订单业绩', 
    dataIndex: 'personalRevenue',
    align: 'center',
    render: text => text || '-'
  }, { 
    title: '消耗业绩', 
    dataIndex: 'consumeRevenue',
    align: 'center',
    render: text => text || '-'
  }, { 
    title: '更新方式', 
    dataIndex: 'changeType',
    align: 'center',
  }, { 
    title: '更新人', 
    dataIndex: 'operateName',
    align: 'center',
  }, { 
    title: '更新时间', 
    dataIndex: 'updatedAt',
    align: 'center',
  }]

  return (
    <div>
      <Descriptions column={2}>
        <Descriptions.Item label="年月">{editData.yearMonth}</Descriptions.Item>
        <Descriptions.Item label="部门">{editData.departmentName}</Descriptions.Item>
        <Descriptions.Item label="员工姓名">{editData.staffName}</Descriptions.Item>
        <Descriptions.Item label="员工编号">{editData.staffNo}</Descriptions.Item>
      </Descriptions>
      <Table 
        rowKey={(record, i) => i}
        columns={logCol} 
        dataSource={logList}
        pagination={false}
        size="middle"
        style={{ marginTop: '30px' }}
      />
    </div>
  )
}

export default ChangeLog
